import type { GetInvoicesOverviewsNewResponse } from '@vy/api-definition';
import { vySerialize } from '@vy/utils';
import { useMutation, UseMutationOptions } from 'react-query';
import { useInvoicesPageParamsNew } from '../../../pages/invoices/hooks/use-invoices-page-params-new';
import { queryKeys } from '../../../services/query-key/query-keys';
import { invoicesOverviewsNewQuery } from './use-invoices-overviews-new';

const PAGE = 0;
const PAGE_SIZE = 100000;

export function useNonPagedInvoicesOverviewsFromParams(
  options?: UseMutationOptions<GetInvoicesOverviewsNewResponse, unknown>,
) {
  const params = useInvoicesPageParamsNew();

  const payload = {
    search: params.search,
    issuedDates: vySerialize(params.issuedDates),
    filters: vySerialize(params.filters),
    page: PAGE,
    pageSize: PAGE_SIZE,
    sort: vySerialize(params.currentSortModel),
  };

  return useMutation({
    mutationKey: queryKeys.invoicesOverviewsNew(...Object.values(payload)),
    mutationFn: async () => {
      return invoicesOverviewsNewQuery(payload);
    },
    ...options,
  });
}
